import React, { useState, useRef, useCallback, useContext } from 'react';
import { Icon } from '@material-ui/core';
import TouchRipple from '@material-ui/core/ButtonBase';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import clsx from 'clsx';
import { AppControlContext } from 'app/contexts/AppControlContext';
import { AppShopContext } from 'app/contexts/AppShopContext';
import { AppSelectShopContext } from "app/contexts/AppSelectShopContext";
import { DeveloperUuidContext } from "app/contexts/DeveloperUuidContext";

const useStyles = makeStyles(({ palette, ...theme }) => ({
  expandIcon: {
    transition: 'transform 0.3s cubic-bezier(0, 0, 0.2, 1) 0ms',
    transform: 'rotate(90deg)',
  },
  collapseIcon: {
    transition: 'transform 0.3s cubic-bezier(0, 0, 0.2, 1) 0ms',
    transform: 'rotate(0deg)',
  },
  'expansion-panel': {
    overflow: 'hidden',
    transition: 'max-height 0.3s cubic-bezier(0, 0, 0.2, 1)',
  },
  highlight: {
    background: palette.primary.main,
  },
  navItem: {
    // color: palette.type === "dark" ? palette.text.secondary : "inherit",
    '&:hover': {
      backgroundColor: palette.action.hover,
    },
  },
  compactNavItem: {
    width: 44,
    overflow: 'hidden',
    justifyContent: 'center !important',
    '& $itemText': {
      display: 'none',
    },
    '& $itemIcon': {
      display: 'none',
    },
  },
  itemIcon: {},
  itemText: {
    fontSize: '0.875rem',
    paddingLeft: '0.8rem',
    // color: "yellow",//サイドバーの > ありテキスト色
    fontWeight: "bold",
  },
  bulletIcon: {
    background: palette.text.secondary,
  },
}));

const useStyles2 = makeStyles(({ palette, ...theme }) => ({
  expandIcon: {
    transition: 'transform 0.3s cubic-bezier(0, 0, 0.2, 1) 0ms',
    transform: 'rotate(90deg)',
  },
  collapseIcon: {
    transition: 'transform 0.3s cubic-bezier(0, 0, 0.2, 1) 0ms',
    transform: 'rotate(0deg)',
  },
  'expansion-panel': {
    overflow: 'hidden',
    transition: 'max-height 0.3s cubic-bezier(0, 0, 0.2, 1)',
  },
  highlight: {
    background: palette.primary.main,
  },
  navItem: {
    // color: palette.type === "dark" ? palette.text.secondary : "inherit",
    '&:hover': {
      //backgroundColor: palette.action.hover,
      //background: '#fda57f',
      background: 'rgba(253, 165, 127, .2)',//プルダウンのラベル

    },
  },
  compactNavItem: {
    width: 44,
    overflow: 'hidden',
    justifyContent: 'center !important',
    '& $itemText': {
      display: 'none',
    },
    '& $itemIcon': {
      display: 'none',
    },
  },
  itemIcon: {},
  itemText: {
    fontSize: '0.875rem',
    paddingLeft: '0.8rem',
    color: "#000000",//サイドバーの > ありテキスト色
    fontWeight: "bold",
  },
  bulletIcon: {
    background: palette.text.secondary,
  },
  hidden: {
    display: 'none !important',
  }
}));


const MatxVerticalNavExpansionPanel = ({ item, children, mode }) => {
  const [collapsed, setCollapsed] = useState(true);
  const classes = useStyles();
  const classes2 = useStyles2();
  const elementRef = useRef(null);
  const componentHeight = useRef(0);
  const { pathname } = useLocation();
  const { isAppControl } = useContext(AppControlContext)
  //const { isAppShop } = useContext(AppShopContext)
  const { name, icon, iconText,
    // badge
  } = item;

  const { appSelectShopName, setAppSelectShopName } = useContext(AppSelectShopContext)
  const { appSelectShopId, setAppSelectShopId } = useContext(AppSelectShopContext)

  const { developerUuId, setDeveloperUuId } = useContext(DeveloperUuidContext)
  const { authority, setAuthority } = useContext(DeveloperUuidContext)

  //const appShopContext = useContext(AppShopContext)
  const { developerId, setDeveloperId } = useContext(AppShopContext)
  //console.log('========= developerUuId ====', developerUuId)
  //console.log('========= authority ========', authority)

  const handleClick = () => {
    componentHeight.current = 0;
    calcaulateHeight(elementRef.current);
    setCollapsed(!collapsed);
  };

  const calcaulateHeight = useCallback((node) => {
    if (node.name !== 'child') {
      for (let child of node.children) {
        calcaulateHeight(child);
      }
    }

    if (node.name === 'child') componentHeight.current += node.scrollHeight;
    else componentHeight.current += 44; //here 44 is node height
    return;
  }, []);

  useEffect(() => {
    if (!elementRef) return;

    calcaulateHeight(elementRef.current);

    // OPEN DROPDOWN IF CHILD IS ACTIVE
    for (let child of elementRef.current.children) {
      if (child.getAttribute('href') === pathname) {
        setCollapsed(false);
      }
    }
  }, [pathname, calcaulateHeight]);
  //console.log('name', name)
  return (
    <div className={
      /*
      clsx('',
        isAppControl ?
          item.name != '店舗' && item.name != 'ブランド' ?
            (item.name == 'イートイン商品' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'テイクアウト商品' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'デリバリー商品' && appSelectShopId != '' && appSelectShopId != undefined) ? '' : classes2.hidden
            : null
          : null)
          */
      clsx('',
        isAppControl
          //全店舗共通メニュー（storeId = 9999）は店舗未選択かつ authority が 1 のときだけ表示する
          ? item.allShop
            ? authority == 1 && (appSelectShopId == '' || appSelectShopId == undefined)
              ? ''
              : classes2.hidden
            : item.name != '店舗' && item.name != 'ブランド' && item.name != 'プッシュ情報（一括登録・配信）' && item.name != 'クーポン（一括登録・配信）' && item.name != 'テーブルオーダー（一括登録・配信）'
            ? (item.name == 'イートイン商品' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'テイクアウト商品' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'デリバリー商品' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'クーポン' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'プッシュ情報' && appSelectShopId != '' && appSelectShopId != undefined) ||
              (item.name == 'テーブルオーダー' && appSelectShopId != '' && appSelectShopId != undefined)
              ? ''
              : classes2.hidden
            : (item.name == '店舗' && (appSelectShopId == '' || appSelectShopId == undefined)) ||
              (item.name == 'ブランド' && authority == 1 && (appSelectShopId == '' || appSelectShopId == undefined)) ||
              (item.name == 'プッシュ情報（一括登録・配信）' && authority == 1 && (appSelectShopId == '' || appSelectShopId == undefined)) ||
              (item.name == 'クーポン（一括登録・配信）' && authority == 1 && (appSelectShopId == '' || appSelectShopId == undefined)) ||
              (item.name == 'テーブルオーダー（一括登録・配信）' && authority == 1 && (appSelectShopId == '' || appSelectShopId == undefined))
              ? ''
              : classes2.hidden
          : null
      )

    }
    >
      <TouchRipple
        className={clsx({
          'flex justify-between h-44 border-radius-4 mb-2 w-full pr-4 has-submenu compactNavItem whitespace-pre overflow-hidden': true,
          [classes.navItem]: !isAppControl ? true : false,
          [classes2.navItem]: !isAppControl ? false : true,
          [classes.compactNavItem]: mode === 'compact',
          open: !collapsed,
        })}
        onClick={handleClick}
      >
        <div className="flex items-center">
          {icon && <Icon className="align-middle text-18 w-36 px-4" color={!isAppControl ? 'white' : "primary"}>{icon}</Icon>}
          {iconText && <div className={clsx('w-4 h-4 rounded bg-white ml-5 mr-2', classes.bulletIcon)}></div>}
          <span className={clsx('align-middle sidenavHoverShow', !isAppControl ? classes.itemText : classes2.itemText)}>{name}</span>
        </div>
        {/* {badge && (
                    <div
                        className={clsx(
                            `rounded bg-${item.badge.color} px-1 py-1px`,
                            'sidenavHoverShow',
                            classes.itemIcon
                        )}
                    >
                        {badge.value}
                    </div>
                )} */}
        <div
          className={clsx({
            'item-arrow sidenavHoverShow': true,
            [classes.itemIcon]: true,
            [classes.collapseIcon]: collapsed,
            [classes.expandIcon]: !collapsed,
          })}
        >
          <Icon fontSize="small" className="align-middle" color={!isAppControl ? 'white' : "primary"}>
            chevron_right
          </Icon>
        </div>
      </TouchRipple>

      <div
        ref={elementRef}
        className={clsx(classes['expansion-panel'], 'submenu')}
        style={collapsed ? { maxHeight: '0px' } : { maxHeight: componentHeight.current + 'px' }}
      >
        {children}
      </div>
    </div>
  );
};

export default MatxVerticalNavExpansionPanel;

